import {useRef} from 'react';


/**
 * Returns a ref and scroll to function
 */
function useScrollTo() {

    const ref = useRef(null);

    const scrollTo = () => {
        if (ref.current) {
            ref.current.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        }
    };

    return {
        ref,
        scrollTo
    };
}


export default useScrollTo;
